document.addEventListener('DOMContentLoaded', function () {
  const colorMap = {
    'white': '#ffffff',
    'black': '#000000',
    'blue': '#3b5998',
    'brown': '#5c4033',
    'cream': '#f2e9d8',
    'green': '#4a5d3a',
    'grey': '#a9a9a9',
    'khaki': '#c3b091',
    'navy': '#1b2340',
    'pink': '#f3d9e0',
    'purple': '#5e444e',
    'lavender': '#978293',
    'red': '#b22222'
  };

  // "Shop By Color" ke dropdown links dhoondo
  const menuLinks = document.querySelectorAll('.header a, nav a, [class*="menu"] a');

  menuLinks.forEach(function (link) {
    const text = link.textContent.trim().toLowerCase();
    if (colorMap[text] && !link.querySelector('.menu-color-swatch')) {
      const swatch = document.createElement('span');
      swatch.className = 'menu-color-swatch';
      swatch.style.cssText =
        'display:inline-block;width:12px;height:12px;border-radius:3px;' +
        'margin-right:8px;vertical-align:middle;border:1px solid rgba(0,0,0,0.15);' +
        'background-color:' + colorMap[text] + ';';
      link.prepend(swatch);
    }
  });
});